import http from '../utils/http';

export default class ReportIncomeService {
  static async print(id) {
    const { data } = await http.get(`/informe-de-rendimentos/${id}/imprimir`, {
      responseType: 'arraybuffer',
    });
    return data;
  }
}
